import { z } from 'zod';

export const ComplianceAutomationActionTypeZod = z.enum([
    'SetAccountStatus',
    'SetDepositLimit',
    'SendEmail',
    'SendNotification',
    'SendComplianceUpdate',
    'ShowPopup',
]);
export type ComplianceAutomationActionTypeType = z.TypeOf<typeof ComplianceAutomationActionTypeZod>;

export const ComplianceAutomationActionZod = z.object({
    executionOrder: z.number().optional(),
    enabled: z.boolean(),
    actionType: ComplianceAutomationActionTypeZod,
    config: z.record(z.unknown()),
});
export type ComplianceAutomationActionType = z.TypeOf<typeof ComplianceAutomationActionZod>;

export const ComplianceAutomationZod = z.object({
    name: z.string(),
    description: z.string().optional(),
    enabled: z.boolean(),
    actions: z.array(ComplianceAutomationActionZod),
});
export type ComplianceAutomationType = z.TypeOf<typeof ComplianceAutomationZod>;

export const ComplianceAutomationTriggerRequestZod = z.object({
    automation_name: z.string(),
    config: z.record(z.unknown()),
    request_id: z.string().optional(),
});
export type ComplianceAutomationTriggerRequestType = z.TypeOf<typeof ComplianceAutomationTriggerRequestZod>;
